import { TextFieldProps } from '@mui/material';
import { forwardRef } from 'react';

import TextFieldWrapper, { TextFieldBase } from '../../wrappers/TextFieldWrapper';

export type AtomTextFieldComponentType = 'wrapper' | 'base';

export type IAtomInputProps = TextFieldProps & {
  componentType?: AtomTextFieldComponentType;
};

const AtomTextField = forwardRef<HTMLDivElement, IAtomInputProps>(({ componentType, ...props }, ref) => {
  const Component = componentType === 'base' ? TextFieldBase : TextFieldWrapper;

  return <Component ref={ref} {...props} />;
});

AtomTextField.displayName = 'AtomTextField';

export default AtomTextField;
